import { usePaymentRequestStore } from "src/stores/payment-request";

export function useProcess() {
  const { toggleProcessPaymentForm } = usePaymentRequestStore();

  const loading = ref(false);

  const processPaymentRequestForm = async () => {
    try {
      toggleProcessPaymentForm({
        edit: true,
        level: 0,
        open: true,
        view: true,
      });
    } catch (error) {
      console.error(error);
    }
  };

  const processButton = computed(() => {
    return {
      loading: unref(loading),
      label: "Process Payment",
      type: "button",
      onClick: processPaymentRequestForm,
    };
  });

  return {
    processButton,
  };
}
